export default __webpack_public_path__ + "static/media/hygiene-rating.167425c6.jpg";